<template>
  <div className="animated">
    <div class="animated fadeIn">
      <b-modal
        id="modal-lg"
        ref="infoModal"
        centered
        size="lg"
        title="Detalle de guia de despacho"
        @ok="waybill = null"
        ok-only
      >
        <div class="text-center">
          <b-spinner v-if="!waybill" label="Spinning"></b-spinner>
        </div>
        <report v-if="waybill" :waybill="waybill"></report>
      </b-modal>
      <b-row class="my-2">
        <b-col>
          <h1 class="text-uppercase font-weight-bold">Listado de Guías de despacho</h1>
        </b-col>
        <b-col>
          <b-form>
            <b-row>
              <b-col>
                <label for="monthSelect">Seleccione mes</label>
                <b-form-select
                  id="monthSelect"
                  v-model="selected.month"
                  :plain="true"
                  :options="selectOptions.months"
                  value="Seleccione..."
                >
                </b-form-select>
              </b-col>
              <b-col>
                <label for="yearSelect">Año</label>
                <b-form-select
                  id="yearSelect"
                  v-model="selected.year"
                  :plain="true"
                  :options="selectOptions.years"
                  value="Seleccione..."
                >
                </b-form-select>
              </b-col>
            </b-row>
          </b-form>
        </b-col>
      </b-row>
      <v-server-table :url="url" :columns="columns" :options="options" :theme="theme" ref="table" id="dataTable">
        <template slot="afterFilter">
          <b-button class="mr-1" @click.prevent="resetFilters">Limpiar filtro</b-button>
          <download-excel
            class="btn"
            :fetch="fetchData"
            :fields="json_fields"
            worksheet="Procesos"
            :name="name"
            :before-generate="startDownload"
            :before-finish="finishDownload"
          >
            <b-button>Descargar</b-button>
          </download-excel>

          <b-spinner v-if="loading" variant="primary" class="mx-1 mt-1" small label="Small Spinner"></b-spinner>
        </template>
        <template slot="condition" slot-scope="props">
          <b-badge pill :variant="getBadge(props.row.condition)">{{ props.row.condition }}</b-badge>
        </template>
        <template slot="daystay" slot-scope="props">
          <div style="text-align: right">
            <b-badge pill :variant="getDaystayBadge(props.row.daystay)">
              {{ props.row.daystay }}
            </b-badge>
          </div>
        </template>
        <template slot="child_row" slot-scope="props">
          <div><b>Nota productor:</b> {{ props.row.note }}</div>
          <div><b>Nota interna:</b> {{ props.row.internal_note }}</div>
        </template>
        <div slot="total_kilograms" slot-scope="props">
          <div style="text-align: right">
            {{ props.row.total_kilograms.format("0,0.00") }}
          </div>
        </div>
        <div slot="total_pallets" slot-scope="props">
          <div style="text-align: right">{{ props.row.total_pallets }}</div>
        </div>
        <div slot="interplanta" slot-scope="props">
          <div class="text-center" v-if="props.row.interplanta">
            <b-badge :variant="getInterplantaBadge(props.row.interplanta)" v-if="props.row.interplanta === 'recibida'">
              <i class="fa fa-lg fa-check"></i>
            </b-badge>
            <b-badge :variant="getInterplantaBadge(props.row.interplanta)" v-else>
              <i class="fa fa-lg fa-truck"></i>
            </b-badge>
          </div>
        </div>
        <div slot="waybill_date" slot-scope="props">
          <div style="text-align: right">{{ props.row.waybill_date }}</div>
        </div>
        <div class="text-right" slot="actions" slot-scope="props">
          <a
            target="_blank"
            href="#"
            @click.prevent="$router.push({ name: 'despacho-estiba', params: { id: props.row.id } })"
            class="fa fa-lg fa-truck text-primary pr-1"
          ></a>
          <a
            target="_blank"
            href="#"
            @click.prevent="getCompleteWaybill(props.row.id)"
            class="fa fa-lg fa-search text-primary pr-1"
          ></a>
          <a
            target="_blank"
            href="#"
            @click.prevent="editWaybill(props.row.id)"
            class="fa fa-lg fa-edit text-primary"
          ></a
          >&nbsp;
          <a
            target="_blank"
            href="#"
            @click.prevent="downloadWithAxios(props.row.id, props.row.number)"
            class="fa fa-lg fa fa-list text-primary"
            title="Packing List"
          ></a
          >&nbsp;&nbsp;
          <!--            <a target="_blank" @click.prevent="deleteWaybill(props.row.id)" href="#"-->
          <!--               class="fa fa-lg fa-trash text-danger"></a>-->
        </div>
      </v-server-table>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { ServerTable, Event } from "vue-tables-2";
import JsonExcel from "vue-json-excel";
import moment from "moment";
import numeral from "numeral";
import locales from "numeral/locales";
import Report from "../recepcion/Report.vue";
import miniToastr from "mini-toastr";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

numeral.locale("es");
window.axios = require("axios");

var d = new Date();

Vue.use(ServerTable);
Vue.component("downloadExcel", JsonExcel);

export default {
  name: "ListDespacho",
  components: {
    ServerTable,
    Report
  },
  created() {
    this.getProducts();
  },
  mounted() {
    Event.$on("vue-tables.loading", () => {
      this.loading = true;
    });

    Event.$on("vue-tables.loaded", () => {
      this.loading = false;
    });

    if (this.$store.state.user.scope.includes("se-le-agrega-columna-interplanta-en-lista-de-guias")) {
      // Push before the actions column
      this.columns.splice(this.columns.length - 1, 0, "interplanta");
    }

    this.loadYear();
    this.getSelectionSet();
  },
  data() {
    return {
      loading: false,
      waybill: null,
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      json_fields: {
        Pallet: "pallet_number",
        Producto: "product_name",
        "Tipo Producto": "product_type_name",
        Condición: "condition",
        Variedad: "variety_name",
        Formato: "container_name",
        Cantidad: "_total_pallets",
        "Kg Netos": "_total_net_kilograms",
        "Guía Recepcion": "waybill_number",
        "Fecha Recepción": "waybill_date",
        Estadía: "daystay",
        Specs: "specifications",
        Huerto: "origin_name"
      },
      columns: [
        "client_customer_name",
        "number",
        "company_name",
        "recipient_company_name",
        "waybill_date",
        "_total_pallets",
        "_total_net_kilograms",
        "note",
        "actions"
      ],
      selected: {
        product: "",
        product_type: "",
        condition: "",
        month: d.getMonth() + 1,
        year: d.getFullYear()
      },
      selectOptions: {
        products: [],
        product_types: [],
        conditions: [
          { value: "", text: "-------" },
          { value: "Orgánico", text: "Orgánico" },
          { value: "Convencional", text: "Convencional" },
          { value: "Org. (System)", text: "Org. (System)" },
          { value: "Conv. (System)", text: "Conv. (System)" }
        ],
        months: [
          { value: 1, text: "Enero" },
          { value: 2, text: "Febrero" },
          { value: 3, text: "Marzo" },
          { value: 4, text: "Abril" },
          { value: 5, text: "Mayo" },
          { value: 6, text: "Junio" },
          { value: 7, text: "Julio" },
          { value: 8, text: "Agosto" },
          { value: 9, text: "Septiembre" },
          { value: 10, text: "Octubre" },
          { value: 11, text: "Noviembre" },
          { value: 12, text: "Diciembre" }
        ],
        years: []
      },
      data: [],
      productSet: [],
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
      options: {
        // skin: "table table-sm table-hover border-0",
        columnsClasses: {
          _total_net_kilograms: "text-right",
          _total_pallets: "text-right"
        },
        responseAdapter: function (resp) {
          const results = resp.data.results;
          const items = [];
          for (let key in results) {
            const item = results[key];
            results[key].waybill_date = moment(results[key].waybill_date).format("DD-MM-YYYY");
            results[key].total_kilograms = numeral(parseFloat(results[key].total_kilograms));
            items.push(item);
          }

          return {
            data: items,
            count: resp.data.count
          };
        },
        texts: {
          noResults: "No se encontraron registros.",
          filter: "Filtrar:",
          filterBy: "Filtrar por {column}",
          count: " ",
          filterPlaceholder: "Buscar...",
          columns: "Columnas",
          limit: "Registros:",
          loading: "Cargando...",
          defaultOption: "Selecione {column}"
        },
        perPage: 25,
        // columnsDropdown: true,
        filterByColumn: true,
        filterable: ["number", "company_name", "client_customer_name", "waybill_date"],
        listColumns: {
          client_customer_name: []
        },
        headings: {
          number: "Numero",
          company_name: "Emisor",
          recipient_company_name: "Receptor",
          client_customer_name: "Exportadora",
          contact_name: "Contacto",
          waybill_date: "Fecha Guia",
          actions: "Acciones",
          _total_net_kilograms: "KN",
          _total_pallets: "Pallets"
        },
        sortable: [],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          dropdown: false,
          chunk: 10
        }
      },
      json_fields2: {
        Exportadora: "client_customer_name",
        Numero: "number",
        Productor: "company_name",
        "Fecha Guia": "waybill_date",
        "Pallet Total": "total_pallets",
        "Kg Netos Totales": "total_kilograms"
      }
    };
  },
  watch: {
    selected: {
      handler(val) {
        // this.getProductSet(this.selected.product)
      },
      deep: true
    }
  },
  computed: {
    sumMarkedKilograms() {
      let total = 0;
      // total += this.data.reduce((acc, item) => acc + item.total_kilograms.value(), 0);
      total = numeral(total);
      return total;
    },
    url() {
      return (
        "/api/v1/waybill/dispatched_waybills/?" +
        "condition=" +
        this.selected.condition +
        "&product_type=" +
        this.selected.product_type +
        "&variety__product=" +
        this.selected.product +
        "&arrival_month=" +
        this.selected.month +
        "&arrival_year=" +
        this.selected.year
      );
    },
    name() {
      return "ListDespacho " + moment(Date.now()).format("YYYYMMDD h:mm") + ".xls";
    }
  },
  methods: {
    getInterplantaBadge(status) {
      if (status === "en tránsito") {
        return "warning";
      } else if (status === "recibida") {
        return "success";
      } else {
        return "primary";
      }
    },
    getSelectionSet() {
      this.$axios
        .get("/api/v1/client/process_select_input/")
        .then((res) => {
          const client_customers = res.data.client_customers;
          for (let idx in client_customers) {
            const item = {
              id: client_customers[idx]["value"],
              text: client_customers[idx]["text"]
            };
            this.options.listColumns["client_customer_name"].push(item);
          }
        })
        .catch((error) => console.log(error));
    },
    resetFilters() {
      for (var key in this.$refs["table"].query) {
        this.$refs["table"].query[key] = "";
      }
      this.$refs["table"].refresh();
    },
    async fetchData() {
      const response =
        (await this.$axios.get(
          "/api/v1/waybill/dispatched_waybills/?" +
            "condition=" +
            this.selected.condition +
            "&product_type=" +
            this.selected.product_type +
            "&variety__product=" +
            this.selected.product +
            "&arrival_month=" +
            this.selected.month
        )) +
        "&arrival_year=" +
        this.selected.year;

      return response.data.results;
    },

    forceFileDownload(response, a) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Packing List - Guia Despacho #" + a + ".xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    downloadWithAxios(a, b) {
      this.$axios({
        method: "get",
        url: "/api/v1/waybill/" + a + "/packing_list/",
        responseType: "arraybuffer"
      })
        .then((response) => {
          this.forceFileDownload(response, b);
          miniToastr.success("Packing list generado con éxito.", "Packing List:");
        })
        .catch((error) => {
          miniToastr.error("Problemas al generar packing list", "Error:");
          console.log(error);
        });
    },

    startDownload() {
      this.loading = true;
    },
    finishDownload() {
      this.loading = false;
    },
    getCompleteWaybill(a) {
      this.$refs.infoModal.show();
      this.$axios
        .get("/api/v1/waybill/" + a + "/waybill_complete_dispatch/")
        .then((res) => {
          this.waybill = res.data;
        })
        .catch((error) => console.log(error));
    },
    getBadge(condition) {
      return condition === "Orgánico" ? "primary" : "success";
    },
    getDaystayBadge(daystay) {
      return daystay >= 10 ? "danger" : daystay >= 5 ? "warning" : daystay >= 3 ? "success" : "primary";
    },
    getProducts() {
      this.$axios
        .get("/production/get_products/")
        .then((res) => {
          // console.log(res)
          const data = res.data.data;
          const products = [];
          for (let key in data) {
            const product = data[key];
            products.push(product);
          }
          this.selectOptions.products = products;
        })
        .catch((error) => console.log(errors));
    },
    getProductSet(a) {
      this.$axios
        .get("/production/get_product_set/" + a)
        .then((res) => {
          this.selectOptions.product_types = res.data.product_types;
        })
        .catch((error) => (this.selected.product_type = ""));
    },
    deleteWaybill(a) {
      console.log(a);
      this.$axios
        .delete("/api/v1/waybill/" + a + "/")
        .then((res) => {
          this.$refs.table.refresh();
        })
        .catch((error) => console.log(error));
    },
    editWaybill(a) {
      this.$router.push("/despacho/editar/" + a);
    },
    loadYear() {
      for (let ano = 2019; ano <= d.getFullYear(); ano++) {
        this.selectOptions.years.push({ value: ano, text: ano });
      }
    }
  }
};
</script>

<style>
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }

  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }

  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
